// extracted by mini-css-extract-plugin
module.exports = {"playerContainer":"player_playerContainer__yvts4"};